/**
 * @generated SignedSource<<68e1b887705895bd0be99538a9d28695>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TagCreateInput = {
  color: string;
  title: string;
};
export type TodoCategoryTagCreateScreenMutation$variables = {
  id: string;
  input: TagCreateInput;
};
export type TodoCategoryTagCreateScreenMutation$data = {
  readonly todoCategory: {
    readonly tagCreate: {
      readonly todoCategory: {
        readonly id: string;
        readonly tags: ReadonlyArray<{
          readonly color: string;
          readonly id: string;
          readonly title: string;
        }>;
      };
    };
  } | null;
};
export type TodoCategoryTagCreateScreenMutation = {
  response: TodoCategoryTagCreateScreenMutation$data;
  variables: TodoCategoryTagCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TodoCategoryMutation",
    "kind": "LinkedField",
    "name": "todoCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "TagCreatePayload",
        "kind": "LinkedField",
        "name": "tagCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategory",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryTagCreateScreenMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoCategoryTagCreateScreenMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "238e3039eff96a25b8b3b3e6163fba96",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryTagCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation TodoCategoryTagCreateScreenMutation(\n  $id: ID!\n  $input: TagCreateInput!\n) {\n  todoCategory(id: $id) {\n    tagCreate(input: $input) {\n      todoCategory {\n        id\n        tags {\n          id\n          title\n          color\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c4399c79a230204e8355d40a628991e";

export default node;
